import { useCreditStore } from '@/stores/credit';
import type { PreloadHandler } from '@/types/router';

export const preloadPaymentHistory: PreloadHandler = async () => {
  const { getPaymentHistory } = useCreditStore();

  await getPaymentHistory();
};
